var module = 'main', name = 'main/assets/svg/arrow.svg', content = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 10\"><path fill=\"#B3B2AF\" d=\"M8.5 9.1c-.2 0-.5-.1-.7-.3L1.3 2.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l5.9 5.6 5.9-5.6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L9.2 8.8c-.2.2-.5.3-.7.3z\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/arrow.svg
// module id = 1288
// module chunks = 0